import angular from 'angular'
import 'ng-file-upload'

import UploadService from './upload.service'

export default angular.module('app.services.upload', ['ngFileUpload'])
  .service('uploadService', UploadService)
